module.exports = __webpack_public_path__ + "img/icon-link.3f44030b.svg";